export const safeReadSessionJson = (key, fallback) => {
  try {
    const raw = window.sessionStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

export const safeWriteSessionJson = (key, value) => {
  try {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore storage errors (quota, private mode)
  }
};

export const safeReadSessionString = (key, fallback = null) => {
  try {
    const raw = window.sessionStorage.getItem(key);
    return raw ?? fallback;
  } catch {
    return fallback;
  }
};

export const safeWriteSessionString = (key, value) => {
  try {
    if (value === null || value === undefined) {
      window.sessionStorage.removeItem(key);
      return;
    }
    window.sessionStorage.setItem(key, String(value));
  } catch {
    // ignore
  }
};
